<template>
  <v-container>
    <h2>Ils nous ont fait confiance !</h2>

    <v-carousel
        cycle
        height="600"
        hide-delimiter-background
        show-arrows-on-hover
        interval="2000000"
      >
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="i"
        >
          <!-- <v-sheet
            :color="colors[i]"
            height="100%"
          > -->
            <UsersOne :slide="slide" />
          <!-- </v-sheet> -->
        </v-carousel-item>
      </v-carousel>

  </v-container>
</template>


<script>
import UsersOne from './UsersOne'

export default {
  components: { UsersOne },
  data () {
    return {
      slides: [
        {
          before: require('../../assets/hb-avant.jpg'),
          after: require('../../assets/hb-apres.jpg'),
          avatar: 'https://picsum.photos/seed/picsum/200/300',
          name: 'Gael',
          story: 'Entièrement satisfait de mon nouveau jardin'
        },
        {
          before: require('../../assets/hb-avant.jpg'),
          after: require('../../assets/hb-apres.jpg'),
          avatar: 'https://picsum.photos/seed/picsum/200/300',
          name: 'Jacque',
          story: 'Entièrement satisfait de mon nouveau jardin aussi'
        }
      ],
    }
  },
}
</script>
<style scoped>
h2 {
  text-align: center;
}
</style>